
import { alpha, Box, CardActionArea, CircularProgress, Grid, Typography } from "@mui/material";
import { separadorMillares } from "../../../../helpers";




export const TarjetaIndicador = ({ valor, total, color='black', titulo, funcion }) => {

    const percentage = Math.ceil((valor / total) * 100) || 0;


    return (

        <Grid item xs={12} sm={4} md={3}>
            <CardActionArea sx={{height:'100%', border:`2px solid ${color}`, borderRadius:5 }}
                onClick={ () => funcion(titulo) }
            >
                <Box sx={{p:2, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                
                    <Box sx={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', pb:1}}>
                        <Typography variant="h2" sx={{ fontWeight:'bold', color:color, textAlign:'center' }}>
                            { titulo }
                        </Typography>
                    </Box>

                    <Box sx={{ position:'relative', display:'inline-flex', my:1 }}>
                        <CircularProgress  variant="determinate" value={100} size={110} thickness={4} sx={{ color:'#d6d6d6' }}/>
                        
                        <CircularProgress size={110} variant="determinate" value={percentage > 100 ? 100 : percentage}  thickness={4}
                            sx={{ color:color, position:'absolute', left:0, circle: { strokeLinecap:'round' }}} 
                        />
                        
                        <Box sx={{position:'absolute', top:0, left:0, bottom:0, right:0, display:'flex', 
                            flexDirection:'column', alignItems:'center', justifyContent:'center',
                        }}>
                            <Typography variant="h3" sx={{ fontWeight: 'bold', fontSize: 25, color }}>
                                {valor}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{width: '100%', display:'flex', justifyContent:'space-between', 
                        alignItems:'center', pt: 1, borderTop:`2px solid ${alpha(color, 0.3)}`
                    }}>
                        <Typography sx={{fontSize:14, fontWeight: 'bold', color: alpha(color, 0.9), textAlign:'center' }}>
                            Total: {separadorMillares(total)}
                        </Typography>
                        
                        <Box sx={{bgcolor: alpha(color, 0.1), px:1.5, py:0.5, borderRadius:2}}>
                            <Typography sx={{ fontSize: 14, fontWeight: 'bold', color, textAlign:'center' }}>
                                Avance: {percentage}%
                            </Typography>
                        </Box>
                    </Box>

                </Box>
            </CardActionArea>
        </Grid>
            
    )
}
